"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const predicate_1 = require("../predicate/predicate");
const model_algorithm_1 = require("./model-algorithm");
const cox_survival_algorithm_1 = require("../algorithm/regression-algorithm/cox-survival-algorithm/cox-survival-algorithm");
const undefined_1 = require("../../util/undefined");
const errors_1 = require("../errors");
const predicate_errors_1 = require("../predicate/predicate-errors");
const data_field_1 = require("../data-field/data-field");
const lodash_1 = require("lodash");
const algorithm_type_1 = require("../../parsers/json/algorithm-type");
const simple_algorithm_1 = require("../algorithm/simple-algorithm/simple-algorithm");
class Model {
    constructor(modelJson) {
        this.name = modelJson.name;
        this.version = modelJson.version;
        this.algorithms = modelJson.algorithms.map(algorithmWithPredicate => {
            let algorithm;
            const algorithmJson = algorithmWithPredicate.algorithm;
            switch (algorithmJson.algorithmType) {
                case algorithm_type_1.AlgorithmType.CoxSurvivalAlgorithm: {
                    algorithm = new cox_survival_algorithm_1.CoxSurvivalAlgorithm(algorithmJson);
                    break;
                }
                case algorithm_type_1.AlgorithmType.SimpleAlgorithm: {
                    algorithm = new simple_algorithm_1.SimpleAlgorithm(algorithmJson);
                    break;
                }
                default: {
                    throw new Error(`Trying to parse unknown algorithm JSON ${algorithmJson}`);
                }
            }
            const predicate = new predicate_1.Predicate(algorithmWithPredicate.predicate.equation, algorithmWithPredicate.predicate.variables);
            return new model_algorithm_1.ModelAlgorithm(algorithm, predicate);
        });
        this.modelFields = modelJson.modelFields.map(modelField => {
            return new data_field_1.DataField(modelField);
        });
    }
    getAlgorithmForData(data) {
        try {
            return predicate_1.Predicate.getFirstTruePredicateObject(this.algorithms, data)
                .algorithm;
        }
        catch (err) {
            if (err instanceof predicate_errors_1.NoPredicateObjectFoundError) {
                throw new Error(`No matched algorithm found`);
            }
            throw err;
        }
    }
    updateBaselineForModel(newBaselines) {
        return Object.setPrototypeOf(Object.assign({}, this, {
            algorithms: this.algorithms.map(({ predicate, algorithm }) => {
                const newBaselineForCurrentAlgorithm = undefined_1.throwErrorIfUndefined(newBaselines.find(({ predicateData }) => {
                    return predicate.getPredicateResult(predicateData);
                }), new errors_1.NoBaselineFoundForAlgorithm(algorithm.name));
                return algorithm.updateBaseline(newBaselineForCurrentAlgorithm.newBaseline);
            }),
        }), Model.prototype);
    }
    /**
     * Returns all the fields used in the model and all it's algorithms
     *
     * @returns {DataField[]}
     * @memberof Model
     */
    getAllFields() {
        return lodash_1.uniqBy(this.modelFields.concat(lodash_1.flatten(lodash_1.flatten(this.algorithms
            .map(({ algorithm }) => {
            return algorithm;
        })
            .map(algorithm => {
            if (algorithm instanceof cox_survival_algorithm_1.CoxSurvivalAlgorithm) {
                return lodash_1.flatten(algorithm.covariates.map(covariate => {
                    return covariate
                        .getDescendantFields()
                        .concat(covariate);
                }));
            }
            else if (algorithm instanceof simple_algorithm_1.SimpleAlgorithm) {
                return algorithm.output
                    .getDescendantFields()
                    .concat(algorithm.output);
            }
            else {
                throw new Error(`Unknown algorithm type`);
            }
        })))), field => {
            return field.name;
        });
    }
    getModelRequiredFields() {
        return this.modelFields.filter(field => field.isRequired);
    }
    getModelRecommendedFields() {
        return this.modelFields.filter(field => field.isRecommended);
    }
}
exports.Model = Model;
//# sourceMappingURL=model.js.map